"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var PromoRequest;
(function (PromoRequest) {
    var Create = (function (_super) {
        __extends(Create, _super);
        function Create() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = undefined;
            _this.exclusive = undefined;
            _this.active = undefined;
            _this.applyTo = undefined;
            _this.percentage = undefined;
            _this.expirationDate = undefined;
            _this.fixed = undefined;
            _this.roles = undefined;
            return _this;
        }
        return Create;
    }(BaseModel_1["default"]));
    PromoRequest.Create = Create;
    var Update = (function (_super) {
        __extends(Update, _super);
        function Update() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = undefined;
            _this.exclusive = undefined;
            _this.active = undefined;
            _this.applyTo = undefined;
            _this.percentage = undefined;
            _this.expirationDate = undefined;
            _this.fixed = undefined;
            _this.roles = undefined;
            return _this;
        }
        return Update;
    }(BaseModel_1["default"]));
    PromoRequest.Update = Update;
    var Assign = (function (_super) {
        __extends(Assign, _super);
        function Assign() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.promoId = undefined;
            _this.itemIds = undefined;
            return _this;
        }
        return Assign;
    }(BaseModel_1["default"]));
    PromoRequest.Assign = Assign;
})(PromoRequest = exports.PromoRequest || (exports.PromoRequest = {}));
var PromoResponse;
(function (PromoResponse) {
    var Promo = (function (_super) {
        __extends(Promo, _super);
        function Promo() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.name = undefined;
            _this.exclusive = undefined;
            _this.active = undefined;
            _this.applyTo = undefined;
            _this.percentage = undefined;
            _this.expirationDate = undefined;
            _this.fixed = undefined;
            _this.tags = undefined;
            _this.books = undefined;
            _this.roles = undefined;
            return _this;
        }
        return Promo;
    }(BaseModel_1["default"]));
    PromoResponse.Promo = Promo;
    var All = (function (_super) {
        __extends(All, _super);
        function All(objects, length, offset, pagination) {
            if (length === void 0) { length = 0; }
            if (offset === void 0) { offset = 0; }
            if (pagination === void 0) { pagination = 100; }
            var _this = _super.call(this) || this;
            _this.objects = undefined;
            _this.length = 0;
            _this.offset = 0;
            _this.pagination = 100;
            _this.objects = objects;
            _this.length = length;
            _this.offset = offset;
            _this.pagination = pagination;
            return _this;
        }
        return All;
    }(BaseModel_1["default"]));
    PromoResponse.All = All;
})(PromoResponse = exports.PromoResponse || (exports.PromoResponse = {}));



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/promo.js
// module id = ../model/dist/models/promo.js
// module chunks = main